import { CircularProgress, TableFooter, TablePagination, Tooltip } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import CheckIcon from '@material-ui/icons/Check';
import SearchIcon from '@material-ui/icons/Search'; 
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';

export function CustomTable({ 
    refresh, 
    setRefresh, 
    columns, 
    dataEndpoint, 
    dataSet, 
    pageSize, 
    enablePaging, 
    title, 
    actions, 
    districtId, 
    addedQuery, 
    hiddenColumns, 
    setHiddenColumns, 
    hiddenColumnsDisabled, 
    tableHeight,
    enableSearch,
    searchPlaceholder
}) {
    const [searchValue, setSearchValue] = useState("");
    const [data, setData] = useState<any[]>([]);
    const [query, setQuery] = useState<any>(null);
    const [numberOfItems, setNumberOfItems] = useState<number>(-1);
    const [pageNumber, setPageNumber] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [hiddenColumnSelect, setHiddenColumnSelect] = useState<boolean>(false);
    const [mouse, setMouse] = useState<any>({});
    const [activeKey, setActiveKey] = useState<string>("");

    useEffect(() => {
        if(addedQuery) {
            setQuery({
                filters: addedQuery,
                pageNumber: 1,
                numberPerPage: 15,
                orderBy: "Id",
                orderByDesc: true
            })
        } else if(refresh && dataEndpoint) {
            setQuery({
                filters: [{
                    property: "DistrictId",
                    value: districtId
                }],
                pageNumber: query?.pageNumber ?? 1,
                numberPerPage: 15,
                orderBy: "CreatedAt",
                orderByDesc: true
            })
        }
    }, [refresh])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(addedQuery){
            setQuery({
                filters: addedQuery,
                pageNumber: 1,
                numberPerPage: 15,
                orderBy: "Id",
                orderByDesc: true
            })
        }
    }, [addedQuery])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (searchValue === "") {
            setPageNumber(0)
        }
    }, [searchValue])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (dataSet) {
            setData(dataSet)
        }
        else {
            getData()
        }
    }, [query, dataSet])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(!enablePaging) return;
        if(numberOfItems !== data.length) {
            setPageNumber(0);
            setNumberOfItems(data.length)
            setCurrentPage(data.slice(0, pageSize))
        }
        else {
            setCurrentPage(data.slice(pageNumber*pageSize, pageNumber*(pageSize)+pageSize))
        }
    }, [data, enablePaging])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(!enablePaging) return;
        setCurrentPage(data.slice(pageNumber*pageSize, pageNumber*(pageSize)+pageSize))
    }, [pageNumber, enablePaging])// eslint-disable-line react-hooks/exhaustive-deps

    const getData = () => {
        if(!query) return;
        setLoading(true)
        dataEndpoint(query)
            .then(x =>{
                setLoading(false)
                setRefresh(false)
                setData(x.items ?? [])
                setNumberOfItems(x.numberOfItems)
            }).catch(x => {
                setLoading(false)
                setRefresh(true)
                alert("Failed to get page.")
            })
    }

    const changePage = (e, page) => {
        setPageNumber(page);
        if (!enablePaging) {
            setQuery({
                ...query,
                pageNumber: page+1
            });
        }
    }

    const handleMenu = (e) => {
        if(hiddenColumnsDisabled) return;
        e.preventDefault()
        setHiddenColumnSelect(true)
        setMouse({
            top: mouseY(e) + 'px',
            left: mouseX(e) + 'px',
            overflow: "auto",
            height: `calc(${tableHeight} - 25px)`
        })
    }

    const updateHiddenColumns = (title) => {
        if(hiddenColumns.some(x => x === title)){
            setHiddenColumns(hiddenColumns.filter(x => x !== title))
        } else {
            let list = Array.from(hiddenColumns);
            list.push(title)
            setHiddenColumns(list)
        }
    }

    function mouseX(evt) {
        if (evt.pageX) {
            return evt.pageX;
        } else if (evt.clientX) {
            return evt.clientX + (document.documentElement.scrollLeft ?
                document.documentElement.scrollLeft :
                document.body.scrollLeft);
        } else {
            return null;
        }
    }

    function mouseY(evt) {
        if (evt.pageY) {
            return evt.pageY;
        } else if (evt.clientY) {
            return evt.clientY + (document.documentElement.scrollTop ?
                document.documentElement.scrollTop :
                document.body.scrollTop);
        } else {
            return null;
        }
    }

    const handleSelect = row => {
        setActiveKey(row)
    }

    return (
        <>
            {hiddenColumnSelect &&
                <div className='show' style={mouse}>
                    {columns.map(x => (
                        <div className='uvp-table-menu' onClick={() => updateHiddenColumns(x.title)} style={{textAlign: "left"}}>
                            {!hiddenColumns.some(y => y === x.title) ?
                                <div style={{ width: "24px", height: "30px" }}>
                                    <CheckIcon style={{ fontSize: "12px", paddingLeft: "2px", stroke: "black", strokeWidth: "2" }} />
                                </div>
                                :
                                <div style={{ width: "24px", height: "30px" }} />
                            }
                            <label style={{padding: "5px 5px 0px 5px", fontSize: "14px"}}>
                                {x.title}
                            </label>
                        </div>
                    ))}
                </div>
            }
            <div style={{ display: "flex", flexDirection: "column", paddingBottom: "0px", backgroundColor: "white"}}>
                <h3 style={{float:"left"}}>{title}</h3>
                {enableSearch && (
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'flex-end', 
                        marginBottom: '5px',  
                        marginTop: title && '10px',
                        alignItems: 'center',
                        fontSize: '14px'
                    }}>
                        <b style={{ marginRight: '10px' }}>Search: </b>
                        <input
                            type="text"
                            placeholder={searchPlaceholder}
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                    setQuery({
                                        ...query,
                                        searchQuery: searchValue,
                                        pageNumber: 1
                                    })
                                }
                            }}
                            className='uvp-input'
                        />
                        <button
                            style={{marginRight: "10px"}}
                            onClick={() => setQuery({ ...query, searchQuery: searchValue, pageNumber: 1 })}
                            className='uvp-search-button'>
                            <SearchIcon />
                        </button>
                    </div>
                )}
                {actions?.some(x => x.isFreeAction) &&
                    actions.filter(x => x.isFreeAction).map(x => (
                        <div style={{ display: "flex", justifyContent:"flex-end", marginTop:"20px", marginBottom: "20px" }}>
                            <Tooltip onClick={x.onClick} title={x.tooltip} style={{ cursor:"pointer" }}>
                                {x.icon()}
                            </Tooltip>
                        </div>
                    ))
                }
                <div style={{ overflowY: "auto", height: tableHeight, scrollbarWidth: "thin" }}>
                    <table
                        aria-label="simple table"
                        style={{
                            borderCollapse: "separate",
                            borderSpacing: 0,
                            width: "100%",
                        }}
                        className="uvp-table"
                        onClick={() => !hiddenColumnsDisabled && setHiddenColumnSelect(false)}
                    >
                        <thead onContextMenu={handleMenu}>
                            <tr onContextMenu={handleMenu}>
                                {columns.map(x => (
                                    <>
                                        {!hiddenColumns.some(y => y === x.title) &&
                                            <th key={x} style={{textAlign: "center"}}>{x.title}</th>
                                        }
                                    </>
                                ))}
                                {actions?.some(x => !x.isFreeAction) &&
                                    <th className='sticky-header'>Actions</th>
                                }
                            </tr>
                        </thead>
                        {loading &&
                            <div className='loading-container'><CircularProgress color="primary" className='center-spinner' /></div>
                        }
                        <tbody>
                            {(enablePaging ? currentPage : data).map((row) => (
                                <tr key={row.id} onClick={() => handleSelect(row)} style={{ backgroundColor: activeKey === row ? "#E3FFDF" : "" }}>
                                    {columns.map(x => (
                                        <>
                                            {!hiddenColumns.some(y => y === x.title) &&
                                                <td key={x}>{x?.render ? x.render(row) : row[x.field]}</td>
                                            }
                                        </>
                                    ))}
                                    {actions?.some(x => !x.isFreeAction) &&
                                        <th className='sticky-column'>
                                            {actions.filter(x => !x.isFreeAction).map(x => (
                                                <>
                                                    {(x.disabled instanceof Function ? x.disabled(row) : x.disabled) ? <div></div> : (
                                                        <Tooltip title={x.tooltip} placement="bottom">
                                                            <span
                                                                onClick={() => x.onClick(row)}
                                                                className={"clickable"}
                                                                style={{marginRight:"5px"}}>
                                                                {x.icon(row)}
                                                            </span>
                                                        </Tooltip>
                                                    )}
                                                </>
                                            ))}
                                        </th>
                                    }
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {data?.length === 0 && !loading &&
                        <div style={{textAlign:"center", margin:"20px 0px", fontSize: "14px"}}>No items to show.</div>
                    }
                </div>
                <TableFooter className='uvp-table-footer'>
                    {numberOfItems > pageSize &&
                        <TablePagination
                            SelectProps={{disabled: loading}}
                            backIconButtonProps={
                                loading
                                ? {
                                    disabled: loading
                                }
                                : undefined
                            }
                            nextIconButtonProps={
                                loading
                                ? {
                                    disabled: loading
                                }
                                : undefined
                            }
                            count={numberOfItems}
                            onPageChange={changePage}
                            page={pageNumber}
                            rowsPerPage={pageSize}
                            rowsPerPageOptions={[]}
                            className='uvp-table-pagination'
                            ActionsComponent={() => TablePaginationActions(numberOfItems, pageNumber, pageSize, changePage)}
                        />
                    }
                </TableFooter>
            </div>
        </>
    )

}

function TablePaginationActions(count, page, rowsPerPage, onPageChange) {

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page">
        <FirstPageIcon />
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page">
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page">
        <LastPageIcon />
      </IconButton>
    </div>
  );
}